import React from 'react';
import ReactTooltip from 'react-tooltip'
// import Joi from 'joi-browser';
import Form from '../../../components/common/Form';
import $ from 'jquery';
import InfoCircle from '../../common/InfoCircle';
import DeleteFeedModal from '../../modals/DeleteFeedModal';
import EditAlphanumericIdModal from '../../modals/EditAlphanumericIdModal';
import FeedInfoEditModal from '../../modals/FeedInfoEditModal';
import TeamsFeed from './TeamsFeed';
import toastr from 'toastr';

import {Popover, Position, PopoverInteractionKind} from "@blueprintjs/core";
import http from "../../../services/httpService";
import {getJwt} from "../../../services/authService";
import Joyride, {STATUS} from "react-joyride";

class FeedInfo extends Form {
    constructor(props) {
        super(props);
        this.state = {
            editing: props.editing,
            data: {
                name: "",
                website: "",
                rss: "",
                id: "",
                team: ""
            },
            feedInfoDotsActive: false,
            errors: {},
            user: this.props.user,
            source: this.props.source,
            selectedSource: this.props.selectedSource,
            activeSubscription: false,
            feedInfoEditModalActive: false,
            deleteFeedModal: false,
            workspaceName: this.props.selectedSourceNode ? this.props.selectedSourceNode.name : "",
            selectedSourceNode: this.props.selectedSourceNode,

            //tour settings
            steps: [
                {
                    content:
                        <div>
                            <h2>Welcome to your Workspace settings!</h2>
                            <p>This is the section where you can manage your selected workspace and add new teammates!
                                🙏
                            </p>
                        </div>,
                    placement: 'center',
                    spotlightPadding: 0,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.workspace-tour-step-1',
                    title: '',
                },
                {
                    content:
                        <div>
                            <h2>Workspace Admins 😎</h2>
                            <p>can manage a specific workspace in Emitto. They can access all workspace settings, run
                                campaigns & keep track of campaign performance, manage distribution channels and manage
                                your audience. They also have access to your Billing details.</p>
                        </div>,
                    placement: 'top',
                    spotlightPadding: 0,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.workspace-tour-step-2',
                    title: '',
                },
                {
                    content: 'To invite your teammates as Workspace Admins click here and input their email addresses! 👇',
                    placement: 'top',
                    spotlightPadding: 0,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.workspace-tour-step-3',
                    title: '',
                },
                {
                    content:
                        <div>
                            <h2>Team admins 👑</h2>
                            <p>can manage all workspaces within a team. They can manage Workspace Admins and Team Admins
                                as well. By default, you as the team creator are the only team admin, but you can invite
                                more admins to join you.
                            </p>
                            <p className='italic'>Note: Both Workspace Admins and Team Admins have complete access to
                                your shared workspaces.
                            </p>
                        </div>,
                    placement: 'top',
                    spotlightPadding: 0,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.workspace-tour-step-4',
                    title: '',
                },
                {
                    content: 'If you want to add teammates as Team Admins click here and move on to Team management section on Emitto. 😉',
                    placement: 'left',
                    spotlightPadding: 0,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.workspace-tour-step-5',
                    title: '',
                },

            ],
            tourRun: false

        };

    }

    cancelSubscriptionsMessage() {
        toastr.error('Please cancel all subscriptions connected to this workspace before deleting!')
    }

    getHelpers = (StoreHelpers) => {
        this.helpers = StoreHelpers;
    };
    runGuidedTour = () => {
        this.setState({
            tourRun: true
        })
    }
    handleJoyrideCallback = (data) => {
        //console.log('joyride callback data: ', data)

        const {status} = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            this.setState({tourRun: false});
        }
        if (data.index === 4 && data.status === 'finished') {
            this.props.history.push('/teams', 'workspace-settings-tutorial')
        }
    }

    // schema = {
    //     name: Joi.string().label("Website Name"),
    //     team: Joi.string().label("Team"),
    //     website: Joi.string().label("Website URL"),
    //     rss: Joi.string().label("RSS"),
    //     id: ""
    // };

    componentDidMount = async () => {

        this.setState({
            data: this.props.selectedSourceNode ? this.props.selectedSourceNode : this.state.data,
            editing: this.props.editing
        });
    }

    componentDidUpdate = async () => {
        let source = await this.props.selectedSourceNode;
        let projectId = source && source.id ? await source.id : source && source.project_id ? await source.project_id :
            await localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        if ((this.state.data && (this.state.data.id !== undefined) ? this.state.data.id !== projectId : this.state.data && (this.state.data.project_id !== undefined) ?
            this.state.data.project_id !== projectId : '') || this.state.editing !== this.props.editing) {

            await this.setState({
                data: source,
                editing: this.props.editing,
                activeSubscription: false
            })
            let active = false
            let activeSubscriptions = ''
            try {
                // console.log('api/user/' + this.state.data.id + '/project/' + this.state.data.id + '/customers/get_subscriptions_project?page=' + '5' + '?page=' + '1')
                const result = await http.get('api/user/' + this.state.user.id + '/project/' + projectId + '/customers/get_subscriptions_project?page=' + '1', {headers: {authorization: getJwt()}});
                // console.log('subscriptions result: ', result)
                activeSubscriptions = result.data.subscriptions.filter(
                    subscription => {
                        return subscription.status === 'active' && subscription.plan.id !== 'free_plan'
                    }
                )
                // console.log('activeSubscriptions: ', activeSubscriptions)
                active = activeSubscriptions.length > 0;
                // console.log('active subscription on project: ', active)
                await this.setState({activeSubscription: active})

            } catch (ex) {
                //toastr.error(ex)
            }

        }

        if (this.state.selectedSourceNode !== this.props.selectedSourceNode) {
            // console.log('this.props.selectedSourceNode: ', this.props.selectedSourceNode)
            this.setState({
                selectedSourceNode: this.props.selectedSourceNode,
                workspaceName: this.props.selectedSourceNode ? this.props.selectedSourceNode.name ? this.props.selectedSourceNode.name : '' : ''
            })
        }
    }

    handleFeedInfoMenu = (e) => {
        // $(this).toggleClass('opened');
        this.setState({
            feedInfoDotsActive: !this.state.feedInfoDotsActive
        })
        $('.feed-edit .platform-dropdown').fadeToggle();
        if (e.target.id === "feed-edit_edit") {
            const selected_src_info = this.state.data || {};
            this.props.toggleFeedInfo(selected_src_info)
        }
    };

    handleAutoPushMenu = (e) => {
        $(this).toggleClass('opened');
        $('.autopush-edit .platform-dropdown').fadeToggle();
        if (e.target.id === "autopush-edit_edit") {
            const selected_src_info = this.state.data || {};
            this.props.toggleFeedInfo(selected_src_info)
        }
    };

    updateProjectData = (project) => {
        this.setState({data: project})
    }

    render() {
        const {steps, tourRun} = this.state
        const {source, openModal, teams, activateFeed, deleteFeed, selectedSource} = this.props;
        const selected_src_info = this.state.data || {};
        //console.log("FeedInfo render  selected_src_info ",  selected_src_info);
        const {editing} = this.state;
        let onlypage = this.props.source ? this.props.source.onlypage : 0;
        return (
            <React.Fragment>
                <div className='flex-end take-panel-width'>
                    <span onClick={this.runGuidedTour} className='start-guided-tour margin-bottom-20'>Start guided
                        tour</span>
                </div>

                <div className="panel-container project-settings-container workspace-tour-step-1">
                    <Joyride
                        callback={this.handleJoyrideCallback}
                        continuous={true}
                        getHelpers={this.getHelpers}
                        run={tourRun}
                        scrollToFirstStep={true}
                        showProgress={true}
                        showSkipButton={true}
                        steps={steps}
                        styles={{
                            options: {
                                zIndex: 10000,
                                primaryColor: '#26AAE1'
                            },
                        }}
                    />

                    <div className="project-header">
                        <h3>{this.state.workspaceName}</h3>

                        <div className="platform-menu feed-edit">
                            {/*<span id="feed-edit" onClick={this.handleFeedInfoMenu} className="fas fa-ellipsis-v"*/}
                            {/*style={{color: this.state.feedInfoDotsActive ? "darkBlue" : "white"}}></span>*/}
                            <Popover
                                interactionKind={PopoverInteractionKind.CLICK}

                                position={Position.LEFT_TOP}
                                minimal={true}
                            >
                                <span id="feed-edit" className="fas fa-ellipsis-v"></span>
                                <div className="project-info-popover padding-10">
                                    <a href="#"
                                       id="feed_info_edit"
                                       title="Feed Info Edit"
                                       name={selected_src_info.name}
                                       slot={selected_src_info.id}
                                        // onBlur={this.handleFeedInTeam}
                                       onClick={(e) => {
                                           this.setState({feedInfoEditModalActive: true})
                                           this.handleFeedInfoMenu(e)
                                       }}
                                       className="popover-link"
                                    >
                                        Rename
                                    </a>
                                    {/*<a className="popover-link" href="# " id={selectedSource} name="deactivate"*/}
                                    {/*   onClick={activateFeed}>Deactivate</a>*/}
                                    <a className="popover-link" href="#" id={selected_src_info.id} name="delete"
                                       onClick={this.state.activeSubscription ? this.cancelSubscriptionsMessage : () => this.setState({deleteFeedModal: true})}>Delete</a>
                                </div>
                            </Popover>
                        </div>
                    </div>

                    <div className="team-card project-settings-info-card margin-bottom-20">
                        <div className="team-header">
                            <h3>Your Date & Time Settings <InfoCircle
                                icon={'question'}
                                infoCircleContent={
                                    <span>Your personal setting reflected in the entire app for your account
                                        only.</span>
                                }
                            /></h3>
                            <div className='add-team-admin add-new'
                                 onClick={(e) => this.props.history.push('/edit-profile/date-time')}>
                                Edit in Profile Settings
                            </div>
                        </div>
                        <div className="team-body flex-direction-row" data-intercom-target="teams-feed-team-body">
                            <div className="flex-column margin-right-20">
                                <span className='profile-date-time-label'>Timezone</span>
                                <span
                                    className='profile-date-time-value'>{this.props.user.locals ? this.props.user.locals.timezone + ' (UTC ' + (this.props.user.locals.offset > 0 ? '+' : '') + this.props.user.locals.offset + ')' : 'Central European Time (UTC +1)'}</span>
                            </div>
                            <div className="flex-column margin-right-20">
                                <span className='profile-date-time-label'>Date format</span>
                                <span
                                    className='profile-date-time-value'>{this.props.user.locals ? this.props.user.locals.date_format : 'DD/MM/YYYY'}</span>
                            </div>
                            <div className="flex-column">
                                <span className='profile-date-time-label'>Time format</span>
                                <span
                                    className='profile-date-time-value'>{this.props.user.locals ? this.props.user.locals.time_format : '24-hour clock'}</span>
                            </div>
                        </div>
                    </div>

                    <TeamsFeed
                        user={this.props.user}
                        openModal={openModal}
                        source={source}
                        teams={teams}
                        history={this.props.history}
                        projectId={selectedSource}
                        selectedSourceNode={this.props.selectedSourceNode}
                        appPropagateTeams={this.props.appPropagateTeams}
                        updateUserFromServer={this.props.updateUserFromServer}
                    />
                    <FeedInfoEditModal
                        showModal={this.state.feedInfoEditModalActive}
                        handleClose={() => this.setState({feedInfoEditModalActive: false})}
                        maxWidth={600}
                        history={this.props.history}
                        user={this.props.user}
                        projectId={selectedSource}
                        updateUserFromServer={this.props.updateUserFromServer}
                        projectName={this.props.selectedSourceNode ? this.props.selectedSourceNode.name : ""}
                    />
                    <DeleteFeedModal
                        showModal={this.state.deleteFeedModal}
                        handleClose={() => this.setState({deleteFeedModal: false})}
                        maxWidth={600}
                        history={this.props.history}
                        user={this.props.user}
                        updateUserFromServer={this.props.updateUserFromServer}
                        selectedSourceNode={this.state.selectedSourceNode}
                        selectProject={this.props.selectSource}
                        updateProjectData={this.updateProjectData}
                    />
                </div>

            </React.Fragment>
        )
    }
}

export default FeedInfo